import React, { useState } from 'react';
import {
    Checkbox,
    FormControlLabel,
    FormGroup,
    Typography,
    Box,
} from '@mui/material';

const daysOfWeek = [
    'Sunday',
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday',
];

export default function WeekdayCheckboxes(props) {

    const { selectedDays, setSelectedDays, error } = props


    const handleChange = (day) => {
        setSelectedDays((prev) =>
            prev.includes(day)
                ? prev.filter((d) => d !== day)
                : [...prev, day]
        );
    };

    return (
        <Box sx={{
            padding: '10px 10px 10px 15px',
            border: '1px solid',
            borderColor: error ? 'error.main' : 'gray',
            borderRadius: 2,
            maxWidth: 250,
            height: '293px',
        }}>
            <Typography variant="h6" sx={{ mb: 0, color: 'rgb(24, 20, 54)' }}>
                Select Days
            </Typography>

            {error && (
                <Typography variant="caption" sx={{ color: 'error.main', display: 'block', mt: 0.5, mb: 0.5 }}>
                    {error}
                </Typography>
            )}

            <div style={{
                fontFamily: 'Inter Regular',
                letterSpacing: '0.5px', fontSize: '13px',
                flexWrap: 'wrap', margin: '5px 5px 5px 0px', color: 'gray'
            }}> Select the days this product will be available</div>
            <FormGroup row sx={{ gap: 2, flexWrap: 'wrap' }}>
                {daysOfWeek.map((day) => (
                    <FormControlLabel
                        key={day}
                        control={
                            <Checkbox
                                checked={selectedDays.includes(day)}
                                onChange={() => handleChange(day)}
                                name={day}
                                sx={{
                                    color: 'gray',

                                    '&.Mui-checked': {
                                        color: 'rgb(24, 20, 54)', // Your requested custom color
                                    },
                                }}
                            />
                        }
                        label={
                            <Typography sx={{ fontSize: '14px' }}>
                                {day}
                            </Typography>
                        }
                        sx={{
                            // m: 0,
                            color: selectedDays.includes(day)
                                ? 'rgb(24, 20, 54)'
                                : 'gray',
                            fontWeight: 500,

                        }}
                    />
                ))}
            </FormGroup>


        </Box>
    );
}